// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://ext-api.pharmacord.com/portaldev/api/v1.0/",
  clientId: "SERNmK8UnwwkCd96qe72YS86BHKKdjDH",
  pdfHost: "https://ext-api.pharmacord.com/portaldev",
  baseUrlEconsent: "https://ext-api.pharmacord.com/gatewaydev/",
  baseUrlDoc: "https://ext-api.pharmacord.com/gatewaydev/api/v1.0/",

  idMeUrl: '',
  webChatUrl: 'https://izervay-dev.pharmacord.com/I3Root',
  sessionTimeout: parseInt(localStorage.getItem('refreshTime'), 10),
  programId: "500034"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
